import { bindRequestLogic } from './utils'
import DataMappingTypes from '../actionTypes/dataMapping'
import { dataMappingAPI } from '../api'

const getDataMappings = bindRequestLogic({
  clientFunc: dataMappingAPI.getDataMappings,
  type: DataMappingTypes.GET_DATA_MAPPINGS_REQUEST,
  successType: DataMappingTypes.GET_DATA_MAPPINGS_SUCCESS,
  failType: DataMappingTypes.GET_DATA_MAPPINGS_FAILED,
  isQueryParam: true
})

const addDataMapping = bindRequestLogic({
  clientFunc: dataMappingAPI.addDataMapping,
  type: DataMappingTypes.ADD_DATA_MAPPING_REQUEST,
  successType: DataMappingTypes.ADD_DATA_MAPPING_SUCCESS,
  failType: DataMappingTypes.ADD_DATA_MAPPING_FAILED
})

const updateDataMapping = bindRequestLogic({
  clientFunc: dataMappingAPI.updateDataMapping,
  type: DataMappingTypes.UPDATE_DATA_MAPPING_REQUEST,
  successType: DataMappingTypes.UPDATE_DATA_MAPPING_SUCCESS,
  failType: DataMappingTypes.UPDATE_DATA_MAPPING_FAILED
})

const deleteDataMapping = bindRequestLogic({
  clientFunc: dataMappingAPI.deleteDataMapping,
  type: DataMappingTypes.DELETE_DATA_MAPPING_REQUEST,
  successType: DataMappingTypes.DELETE_DATA_MAPPING_SUCCESS,
  failType: DataMappingTypes.DELETE_DATA_MAPPING_FAILED
})

export default [
  getDataMappings,
  addDataMapping,
  updateDataMapping,
  deleteDataMapping
]
